import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Wordmark } from "./Logo";
import { Phone } from "lucide-react";

const PHONE = "561-502-6769";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#how", label: "Process" },
    { href: "#find", label: "Find My Car" },
    { href: "#sell", label: "Sell / Trade" },
    { href: "#stories", label: "Stories" },
    { href: "#gallery", label: "Recently Sourced" },
    { href: "#faq", label: "FAQ" },
  ];

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.7, 0, 0.2, 1] }}
      data-testid="site-nav"
      role="banner"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#0A0A0A]/90 backdrop-blur-xl border-b border-[#1c1c1c]" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" aria-label="Strive Motors · home" className="flex items-center">
          <Wordmark height={56} />
        </a>
        <nav aria-label="Primary" className="hidden lg:flex items-center gap-9 text-[13px] uppercase tracking-[0.14em] text-white/85">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="link-sweep hover:text-white">
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href={`tel:${PHONE}`}
          data-testid="nav-call-btn"
          className="hidden md:inline-flex items-center gap-2 px-4 py-2 border border-[#E31E24] text-white hover:bg-[#E31E24] transition-colors duration-300 font-mono2 text-[13px]"
        >
          <Phone size={14} strokeWidth={2.4} />
          <span>{PHONE}</span>
        </a>
      </div>
    </motion.header>
  );
}
